import { useMemo } from "react";
import http from "../../common/utilities/HttpModule";
import useAuth from "../../authProvider/hooks/useAuth";
import useAuthenticationTokens from "../../authProvider/hooks/useAuthenticationTokens";

const useIsAuthenticated = () => {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth();
  const { accessToken } = useAuthenticationTokens();

  // NOTE: this is a genuine render-phase side effect and the rule is right to
  // flag it. It is left in place deliberately: moving it into an effect would
  // set the Authorization header only *after* the first render commits, so any
  // request fired by a child during that first render would go out unauthorized
  // and 401. Fixing this properly means setting the header where the token is
  // produced (authProvider) rather than here, which is out of scope for a
  // lint pass and needs human review.
  if (accessToken) {
    // eslint-disable-next-line react-hooks/immutability -- see above: auth header must be set before first render commits
    http.axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  }

  const isLoading = useMemo(() => {
    if (isAuthenticated) {
      return isAuthLoading || !accessToken;
    }

    return isAuthLoading;
  }, [isAuthLoading, accessToken, isAuthenticated]);

  return { isLoading, isAuthenticated };
};

export default useIsAuthenticated;
